import { render } from "./MessageBoard.vue?vue&type=template&id=2d38b9dd&scoped=true"
import script from "./MessageBoard.vue?vue&type=script&lang=js"
export * from "./MessageBoard.vue?vue&type=script&lang=js"

import "./MessageBoard.vue?vue&type=style&index=0&id=2d38b9dd&scoped=true&lang=scss"

import exportComponent from "/Users/adamklemm/vues/pmp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d38b9dd"]])

export default __exports__